import React from 'react';
import { Col, Card, CardBody, Pagination, PaginationItem, PaginationLink, Row } from 'reactstrap';

import { PaginationColor, Previous, Next } from '../../../Constant';
import HeaderCard from '../../Common/HeaderCard';

const PaginationColorClass = () => {
  return (
    <Col xl='12'>
      <Card>
        <HeaderCard title={PaginationColor} />
        <CardBody>
          <Row>
          <Col>
          <Pagination listClassName='pagination-primary' className='m-b-30' aria-label='Page navigation example'>
            <PaginationItem>
              <PaginationLink href='#javascript'>{Previous}</PaginationLink>
            </PaginationItem>
            <PaginationItem>
              <PaginationLink href='#javascript'>{'1'}</PaginationLink>
            </PaginationItem>
            <PaginationItem>
              <PaginationLink href='#javascript'>{'2'}</PaginationLink>
            </PaginationItem>
            <PaginationItem>
              <PaginationLink href='#javascript'>{'3'}</PaginationLink>
            </PaginationItem>
            <PaginationItem>
              <PaginationLink href='#javascript'>{Next}</PaginationLink>
            </PaginationItem>
          </Pagination>
          <Pagination listClassName='pagination-secondary' className='m-b-30 ' aria-label='Page navigation example'>
            <PaginationItem>
              <PaginationLink href='#javascript'>{Previous}</PaginationLink>
            </PaginationItem>
            <PaginationItem>
              <PaginationLink href='#javascript'>{'1'}</PaginationLink>
            </PaginationItem>
            <PaginationItem>
              <PaginationLink href='#javascript'>{'2'}</PaginationLink>
            </PaginationItem>
            <PaginationItem>
              <PaginationLink href='#javascript'>{'3'}</PaginationLink>
            </PaginationItem>
            <PaginationItem>
              <PaginationLink href='#javascript'>{Next}</PaginationLink>
            </PaginationItem>
          </Pagination>
          <Pagination listClassName='pagination-success' className='m-b-30 pagination-success' aria-label='Page navigation example'>
            <PaginationItem>
              <PaginationLink href='#javascript'>{Previous}</PaginationLink>
            </PaginationItem>
            <PaginationItem>
              <PaginationLink href='#javascript'>{'1'}</PaginationLink>
            </PaginationItem>
            <PaginationItem>
              <PaginationLink href='#javascript'>{'2'}</PaginationLink>
            </PaginationItem>
            <PaginationItem>
              <PaginationLink href='#javascript'>{'3'}</PaginationLink>
            </PaginationItem>
            <PaginationItem>
              <PaginationLink href='#javascript'>{Next}</PaginationLink>
            </PaginationItem>
          </Pagination>
          </Col>
          <Col>
          <Pagination listClassName='pagination-info' className='m-b-30 ' aria-label='Page navigation example'>
            <PaginationItem>
              <PaginationLink href='#javascript'>{Previous}</PaginationLink>
            </PaginationItem>
            <PaginationItem>
              <PaginationLink href='#javascript'>{'1'}</PaginationLink>
            </PaginationItem>
            <PaginationItem>
              <PaginationLink href='#javascript'>{'2'}</PaginationLink>
            </PaginationItem>
            <PaginationItem>
              <PaginationLink href='#javascript'>{'3'}</PaginationLink>
            </PaginationItem>
            <PaginationItem>
              <PaginationLink href='#javascript'>{Next}</PaginationLink>
            </PaginationItem>
          </Pagination>
          <Pagination listClassName='pagination-warning' className='m-b-30 ' aria-label='Page navigation example'>
            <PaginationItem>
              <PaginationLink href='#javascript'>{Previous}</PaginationLink>
            </PaginationItem>
            <PaginationItem>
              <PaginationLink href='#javascript'>{'1'}</PaginationLink>
            </PaginationItem>
            <PaginationItem>
              <PaginationLink href='#javascript'>{'2'}</PaginationLink>
            </PaginationItem>
            <PaginationItem>
              <PaginationLink href='#javascript'>{'3'}</PaginationLink>
            </PaginationItem>
            <PaginationItem>
              <PaginationLink href='#javascript'>{Next}</PaginationLink>
            </PaginationItem>
          </Pagination>
          <Pagination aria-label='Page navigation example pagination-danger'>
            <PaginationItem>
              <PaginationLink href='#javascript'>{Previous}</PaginationLink>
            </PaginationItem>
            <PaginationItem>
              <PaginationLink href='#javascript'>{'1'}</PaginationLink>
            </PaginationItem>
            <PaginationItem>
              <PaginationLink href='#javascript'>{'2'}</PaginationLink>
            </PaginationItem>
            <PaginationItem>
              <PaginationLink href='#javascript'>{'3'}</PaginationLink>
            </PaginationItem>
            <PaginationItem>
              <PaginationLink href='#javascript'>{Next}</PaginationLink>
            </PaginationItem>
          </Pagination>
          </Col>
          </Row>
        </CardBody>
      </Card>
    </Col>
  );
};

export default PaginationColorClass;
